package com.yogaaicoach.pages.trainingprogram

// Mirrors composeApp's AgeGroupKey enum (pages/trainingprogram/data/models/AgeGroupKey.kt) —
// already a plain enum there, no stripping needed.
enum class AgeGroupKey {
    UNDER_30,
    AGE_30_39,
    AGE_40_49,
    AGE_50_64,
    OVER_65,
}
